// Dados estaticos do site Cicarpe - extraidos do site de producao
// Todas as imagens sao hospedadas no Cloudinary

export const clinicInfo = {
  name: "Cicarpe",
  fullName: "Clinica Cicarpe",
  tagline: "Cuidando do seu coração com excelência e dedicação.",
  description: "Centro especializado em cardiologia com equipamentos modernos e equipe altamente qualificada.",
  address: "Rua Irmãos D'Angelo, 48, salas 501 e 502 - Centro, Petrópolis - RJ, 25685-330",
  phone: "(24) 2243-3968",
  whatsapp: "5524981100970",
  email: "contato@cicarpe.com.br",
  hours: {
    weekdays: "Segunda a Sexta: 8h às 18h",
    saturday: "Sábado: 8h às 12h",
    sunday: "Domingo: Fechado"
  },
  logo: "https://res.cloudinary.com/dbgwb0l8w/image/upload/v1763913553/cicarpe-media/f5telvuovlcu2h5dfbly.png"
};

export const banners = [
  {
    id: "banner-1",
    title: "Exames cardiológicos de excelência em Petrópolis",
    subtitle: "Há mais de 45 anos cuidando do seu coração com tecnologia de ponta e equipe altamente qualificada",
    image: "https://res.cloudinary.com/dbgwb0l8w/image/upload/v1769724407/cicarpe-media/obwmviput3iooeoexqtf.png",
    text_color: "#ffffff",
    show_button: true,
    button_text: "AGENDAMENTO"
  },
  {
    id: "banner-2",
    title: "Tradição",
    subtitle: "Desde 1979, o CICARPE é referência em exames complementares em cardiologia.",
    image: "https://res.cloudinary.com/dbgwb0l8w/image/upload/v1769726153/cicarpe-media/ca2hdrwcahfhoxam4ehn.png",
    text_color: "#ffffff",
    show_button: true,
    button_text: "AGENDAR CONSULTA"
  },
  {
    id: "banner-3",
    title: "Por que levar crianças ao cardiologista?",
    subtitle: "Muitos problemas cardíacos não apresentam sintomas claros na infância",
    image: "https://res.cloudinary.com/dbgwb0l8w/image/upload/v1769726656/cicarpe-media/gkusnljpp01fxqoeuztw.png",
    text_color: "#ffffff",
    show_button: true,
    button_text: "AGENDAR CONSULTA"
  },
  {
    id: "banner-4",
    title: "Profissionalismo e Tecnologia",
    subtitle: "",
    image: "https://res.cloudinary.com/dbgwb0l8w/image/upload/v1769737112/cicarpe-media/g30mkeyrudn8ldrnr0bs.png",
    text_color: "#ffffff",
    show_button: true,
    button_text: "AGENDAR CONSULTA"
  },
  {
    id: "banner-5",
    title: "Conheça Nosso Espaço",
    subtitle: "Tradição, tecnologia e precisão em cardiologia",
    image: "https://res.cloudinary.com/dbgwb0l8w/image/upload/v1769739308/cicarpe-media/ydqmic2ec6iq14oul3yl.png",
    text_color: "#ffffff",
    show_button: true,
    button_text: "AGENDAR CONSULTA"
  },
  {
    id: "banner-6",
    title: "Equipe de Excelência em Cardiologia",
    subtitle: "Nossa equipe reúne profissionais com formação nos melhores centros do país e ampla experiência clínica.",
    image: "https://res.cloudinary.com/dbgwb0l8w/image/upload/v1769740010/cicarpe-media/a2dmzbw8eeslcwvprepn.png",
    text_color: "#ffffff",
    show_button: true,
    button_text: "AGENDAR CONSULTA"
  }
];

export const services = [
  {
    id: "srv-1",
    title: "Eletrocardiograma",
    description: "O eletrocardiograma detecta anormalidades na condutividade elétrica do coração e pode ajudar a identificar doenças nesse órgão. Isso porque avalia a funcionalidade do músculo cardíaco e se ela está adequada conforme os sintomas relatados pelo indivíduo.",
    icon: "ClipboardList"
  },
  {
    id: "srv-2",
    title: "Ecodopplercardiograma com Strain",
    description: "Análise avançada da função cardíaca que detecta alterações antes dos sintomas. Essencial para diagnóstico precoce de insuficiência cardíaca, monitoramento de quimioterapia e doenças valvares.",
    icon: "Monitor"
  },
  {
    id: "srv-3",
    title: "Ecocardiograma",
    description: "Exame de imagem não invasivo realizado por ultrassom. Permite a visualização detalhada da anatomia cardíaca em tempo real, avaliando o funcionamento das válvulas, o tamanho das câmaras e a capacidade de bombeamento do sangue (fração de ejeção).",
    icon: "HeartPulse"
  },
  {
    id: "srv-4",
    title: "Ecocardiograma Fetal",
    description: "Ele permite identificar alterações cardíacas ainda durante a gestação, avaliando com precisão a estrutura, o tamanho, o desenvolvimento e o funcionamento do coração do feto, incluindo válvulas, músculos cardíacos e o fluxo sanguíneo.",
    icon: "Stethoscope"
  },
  {
    id: "srv-5",
    title: "MAPA e Holter 24h",
    description: "Exame que registra continuamente os batimentos e o ritmo do coração por até 24 horas. O paciente utiliza um pequeno monitor portátil durante sua rotina normal, permitindo uma avaliação precisa do funcionamento cardíaco no dia a dia. Não é permitido molhar o aparelho durante o exame.",
    icon: "Clipboard"
  },
  {
    id: "srv-6",
    title: "Doppler de Carótidas",
    description: "O Doppler de carótidas e vertebrais é um exame que tem por objetivos o estudo da vascularização das principais artérias que levam sangue em direção ao cérebro. É possível também identificar as placas de gordura que se desenvolvem no interior das artérias (aterosclerose), quantificar a obstrução e medir a espessura da parede da artéria.",
    icon: "Brain"
  },
  {
    id: "srv-7",
    title: "Cardiologia Pediátrica",
    description: "Cuidado especializado para o coração dos pequenos. Detecta malformações congênitas e acompanha o desenvolvimento cardíaco desde o nascimento. Consultas regulares com o cardiologista pediátrico e exames de rotina, como ecocardiograma e eletrocardiograma, podem salvar vidas e garantir uma infância saudável.",
    icon: "Plus"
  },
  {
    id: "srv-8",
    title: "RISCO CIRÚRGICO",
    description: "O risco cirúrgico é uma avaliação das condições de saúde do paciente para identificar se existem riscos para a realização de uma cirurgia. É imprescindível saber a história do paciente, examiná-lo e solicitar alguns exames complementares dependendo do tipo de cirurgia. Agende seu risco conosco e fique mais tranquilo na realização da sua cirurgia, independente da faixa etária.",
    icon: "FileText"
  }
];

export const history = {
  title: "Nossa História",
  content: `Fundado em 1979, o CICARPE nasceu com um propósito claro: oferecer exames cardiológicos de excelência à população de Petrópolis e região, unindo rigor científico, tecnologia e cuidado humano. Pioneirismo em Petrópolis: criado por oito cardiologistas visionários, o CICARPE introduziu a ecocardiografia na cidade e se consolidou como referência ao longo de mais de quatro décadas. Em 1989, foi pioneiro na incorporação do Duplex-Scan vascular. Em 2011, ampliou sua atuação com o serviço de cardiologia pediátrica e fetal. Desde 2003, atua em sede própria e conta com equipamentos de última geração, incluindo ecocardiograma tecidual e novamente de forma pioneira em Petrópolis.

Cada exame é realizado e interpretado por médicos especialistas com formação nos principais centros do país, garantindo precisão, segurança e confiança diagnóstica.

Sob a direção do Dr. Wagner Figueira Rodrigues, fundador do Departamento de Ecocardiografia da Sociedade Brasileira de Cardiologia, o CICARPE mantém sua tradição de liderança, inovação e excelência.`
};

export const team = [
  {
    id: "team-1",
    name: "Dra. Renata Labronici Figueira Rodrigues",
    specialty: "Cardiologista Pediátrica"
  },
  {
    id: "team-2",
    name: "Wagner Figueira Rodrigues",
    specialty: "Cardiologista"
  }
];

export const insurancePlans = [
  "ADEPREV",
  "AMIL",
  "AVAMPE",
  "BRADESCO",
  "CASSI",
  "CLUDE",
  "DOCCTOR MED",
  "ESPAÇO CLÍNICO",
  "GEAP",
  "GOLDEN",
  "IBEN BRASIL",
  "INSTITUTO SANTÉ",
  "INTERMÉDICA/HAPVIDA",
  "KLINI SAÚDE",
  "LEVE SAÚDE",
  "MEDIMASTER",
  "MEDISERVICE",
  "PASA/VALE",
  "PLANO VITAL",
  "PORTO SEGURO",
  "PRUDENTIAL",
  "RHMED",
  "SEPE",
  "SINDICATO DA SAÚDE",
  "SINDICATO DOS PROFESSORES",
  "SINDICATO DOS TRABALHADORES EM TRANSPORTES DE CARGA DE PETRÓPOLIS E SÃO JOSÉ DO VALE DO RIO PRETO",
  "SISEP",
  "SULAMÉRICA",
  "UNIMED"
];

export const whyChoose = {
  title: "Por que escolher o CICARPE?",
  content: "Primeira clínica a realizar ecocardiografia em Petrópolis. Tecnologia de ponta desde 1979. Mais de 45 anos de atuação com equipe especializada e referenciada no Rio de Janeiro. Ecocardiograma com Strain, Doppler vascular e equipamentos de última geração. Equipe qualificada com mestrado e formação nos melhores centros do país. Eletrocardiograma sem marcação de segunda a sábado. Laudos rápidos. Aceita +30 Convênios."
};

export const sections = [
  { id: "sec-hero", type: "hero", title: "Hero", order: 0, visible: true },
  { id: "sec-services", type: "services", title: "Nossos Serviços", order: 1, visible: true },
  { id: "sec-history", type: "custom-history", title: "Nossa História", order: 2, visible: true },
  { id: "sec-team", type: "team", title: "Nossa Equipe", order: 3, visible: true },
  { id: "sec-insurance", type: "insurance", title: "Convênios Aceitos", order: 4, visible: true },
  { id: "sec-contact", type: "contact", title: "Entre em Contato", order: 5, visible: true },
  { id: "sec-why", type: "custom-why", title: "Por que escolher o CICARPE?", order: 6, visible: true }
];
